var map = {
	"./Fauna1.jpg": 5226,
	"./Fauna2.jpg": 9049,
	"./Playas_La_Concha1.jpg": 8551,
	"./Playas_La_Concha2.jpg": 3557,
	"./Playas_La_Concha3.jpg": 1825,
	"./Playas_La_Concha4.jpg": 7382,
	"./Playas_La_Concha5.jpg": 1564,
	"./Playas_La_Concha6.jpg": 8832,
	"./Playas_La_Concha7.jpg": 8157,
	"./Playas_Puertito1.jpg": 4227,
	"./Playas_Puertito2.jpg": 6503,
	"./Playas_Puertito3.jpg": 6785,
	"./Playas_Puertito4.jpg": 8286,
	"./Punto_de_interes_Puertito_de_Lobos1.jpg": 6195,
	"./Punto_de_interes_Puertito_de_Lobos2.jpg": 4363,
	"./Punto_de_interes_Puertito_de_Lobos3.jpg": 6495,
	"./Punto_de_interes_Puertito_de_Lobos4.jpg": 8021,
	"./Punto_de_interes_centro_de_interpretacion1.jpg": 9094,
	"./Punto_de_interes_centro_de_interpretacion14.jpg": 4097,
	"./Punto_de_interes_centro_de_interpretacion2.jpg": 136,
	"./Punto_de_interes_centro_de_interpretacion3.jpg": 8018,
	"./Punto_de_interes_faro1.jpg": 3654,
	"./Senderos1.jpg": 7897,
	"./Senderos2.jpg": 9032,
	"./Senderos3.jpg": 1159,
	"./Senderos4.jpg": 4009,
	"./Senderos5.jpg": 3425,
	"./Senderos6.jpg": 7635,
	"./Senderos7.jpg": 7304,
	"./cabildo-las_lagunitas.jpg": 3299,
	"./centro_de_interpretación_de_lobos.jpg": 8640,
	"./faro_de_lobos.jpg": 6003,
	"./fotos_pardela-autor_manolo_carrillo.jpg": 5549,
	"./las_lagunitas.jpg": 9155,
	"./montaña_de_la_caldera.jpg": 4450,
	"./siempreviva_de_lobos.jpg": 5959,
	"./tabaibas_en_lobos.jpg": 1397,
	"./uvilla_de_mar-tetraena_fontanesii.jpg": 4113,
	"./vista_aérea_de_el_puertito.jpg": 4191,
	"./vista_aérea_de_la_playa_de_la_concha.jpg": 2074,
	"./vista_aérea_de_lobos.jpg": 2302
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2929;